import {styled} from '@vw-marketing/us-components';
interface FadeWrapperProps {
  displayAction: boolean;
}
export const FadeWrapper: any = styled.div<FadeWrapperProps>`
  ${({displayAction}: FadeWrapperProps) =>
    displayAction &&
    `
           display: flex;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
  position: absolute;
  width: calc(100% + 2px);
  height: 100%;
  top: -1px;
  right: -1px;
  z-index: 1;
`}
`;

export const CollapseTextContainer: any = styled.div<{
  dynamicContainer: boolean;
}>`
  display: flex;
  flex-flow: column;
  height: ${({dynamicContainer}: any) => (dynamicContainer ? `100%` : `auto`)};
`;

export interface CollapseTextWrapperProps {
  containerHeight?: number;
}
export const CollapseTextWrapper: any = styled.div<CollapseTextWrapperProps>`
  ${(props: any) => `
  display: flex;
            height: ${
              props.containerHeight ? `${props.containerHeight}em` : `auto`
            };
        `}
  position: relative;
`;
interface TextWrapperProps {
  lines?: number;
  height: number;
}
export const TextWrapper: any = styled.div<TextWrapperProps>`
  ${(props: TextWrapperProps) => `
  display: flex;
  height: ${props.height ? `${props.height}em` : `auto`};

  overflow: hidden;
  p {
    overflow: hidden;
${props.lines &&
  `
    display: -webkit-box;
    display: box;
    -webkit-line-clamp: ${props.lines};
    -webkit-box-orient: vertical;
    `}
    background:#fff;
    height: 100%;
  }
  `}
`;

export const ButtonViewMoreWrapper: any = styled.div`
  padding-top: 10px;
  padding-bottom: 2px;
`;
